<template>
    <div>
        <v-select :items="computedCategories" v-model="categoryId" label="Kundegruppe" hide-details/>
        <customer-category-dialog v-model="dialog" @create="setCreated"/>
    </div>
</template>

<script>
    import {debounce} from 'lodash';
    import CustomerCategoryDialog from './CustomerCategoryDialog';

    export default {
        props: ['value', 'placeholder'],
        components: {
            CustomerCategoryDialog
        },

        data() {
            return {
                categoryId: this.value || null,
                categories: [],
                dialog: false
            }
        },

        created() {
            this.loadData();
        },

        methods: {
            loadData() {
                this.$http.get(`customer-categories`).then(response => {
                    this.categories = response.data.data;
                });
            },

            setCreated(newId) {
                this.categoryId = newId;
            }
        },

        watch: {
            categoryId() {
                if (this.categoryId === 'manage') {
                    this.dialog = true;
                    this.categoryId = null;
                    return;
                }
                this.$emit('input', this.categoryId);
            },
            dialog() {
                if (!this.dialog) return this.loadData();
            }
        },

        computed: {
            computedCategories() {
                return [
                    {text: this.placeholder ? this.placeholder : 'Alle', value: null},
                    ...this.categories.map(c => {
                        return {text: c.name, value: c.id}
                    }),
                    {text: 'Legg til / fjern', value: 'manage'}
                ]
            }
        }
    }
</script>
